import {SystemStatus} from "../../gd/const/system-status"

export enum TaskSystemType {
    TASK        = 1,
    SUBTASK     = 2,
    // PROJECT= 3
}

export type RelatedTaskData = {
    id                      : ID
    title                   : string
    projectId               : ID
    shortId                 : ID
    taskTypeId              : ID
    statusId                : ID
    systemType              : TaskSystemType
    sortPosition            : number
    actionRequiredUserId?   : ID
    parentTaskId            : ID
    systemStatus            : SystemStatus
}

export type ProgressSubItems = {
    done    : number
    total   : number
}


export type RelatedTasks = {
    siblings?       : ID[],
    dependencies?   : {
        id      : ID,
        type    : number,
        task1Id : ID,
        task2Id : ID
    }[],
    subtasks?       : ID[],
    tasksData?      : RelatedTaskData[]
}

export enum TaskMyWorkType {
    ACTION_REQUIRED = 'action-required',
    ASSIGNED_TO     = 'assigned-to',
    DEADLINE        = 'deadline',
}

export type TypeModelOptions = {
    useProxy?   : boolean
    myWorkType? : TaskMyWorkType
}